
import { useEffect, useState } from 'react';

function getTimeLeft() {
  const eventDate = new Date('2026-03-11T19:30:00-04:00');
  const now = new Date();
  const diff = eventDate.getTime() - now.getTime();

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
}

const TOTAL_SLOTS = 30;
const INITIAL_SLOTS = 23;
const MIN_SLOTS = 5;
const DECREASE_INTERVAL_MS = 45000;

export default function CountdownSection() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);
  const [availableSlots, setAvailableSlots] = useState(INITIAL_SLOTS);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const slotTimer = setInterval(() => {
      setAvailableSlots((prev) => {
        if (prev <= MIN_SLOTS) {
          clearInterval(slotTimer);
          return MIN_SLOTS;
        }
        return prev - 1;
      });
    }, DECREASE_INTERVAL_MS);
    return () => clearInterval(slotTimer);
  }, []);

  const filledSlots = TOTAL_SLOTS - availableSlots;

  return (
    <section className="py-10 sm:py-12 bg-gray-950">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="bg-black/80 border border-yellow-500/30 rounded-2xl px-5 sm:px-8 py-6 sm:py-8">

          {/* Vagas restantes */}
          <div className="mb-6">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="text-red-500 text-lg animate-pulse">🔴</span>
              <p className="text-white font-black text-base sm:text-lg">
                Vagas restantes:{' '}
                <span className="text-red-400 text-xl sm:text-2xl">{availableSlots}</span>
              </p>
            </div>

            <div className="flex justify-center gap-1 mb-2">
              {Array.from({ length: TOTAL_SLOTS }).map((_, index) => {
                let bgColor = 'bg-white/10';
                if (index < filledSlots) {
                  const ratio = index / TOTAL_SLOTS;
                  if (ratio < 0.33) bgColor = 'bg-green-500';
                  else if (ratio < 0.66) bgColor = 'bg-yellow-500';
                  else bgColor = 'bg-red-500';
                }
                return (
                  <div
                    key={index}
                    className={`w-2 h-5 sm:w-2.5 sm:h-6 rounded-sm transition-all duration-700 ${bgColor}`}
                  ></div>
                );
              })}
            </div>

            <p className="text-gray-400 text-xs text-center">
              <span className="text-red-400 font-bold">{availableSlots}</span> de {TOTAL_SLOTS} vagas disponíveis
            </p>
          </div>

          {/* Divisor */}
          <div className="flex items-center gap-3 mb-5 max-w-xs mx-auto">
            <div className="flex-1 h-px bg-yellow-500/20"></div>
            <i className="ri-time-fill text-yellow-500/60 text-sm"></i>
            <div className="flex-1 h-px bg-yellow-500/20"></div>
          </div>

          {/* Contador regressivo */}
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-fire-fill text-red-400 text-lg animate-pulse"></i>
            <p className="text-white font-black text-base sm:text-lg">
              Restam apenas <span className="text-red-400 text-xl sm:text-2xl">{availableSlots}</span> vagas para esta cidade.
            </p>
            <i className="ri-fire-fill text-red-400 text-lg animate-pulse"></i>
          </div>

          <p className="text-gray-400 text-xs font-semibold tracking-widest uppercase text-center mb-4">
            O evento começa em
          </p>

          <div className="flex items-center justify-center gap-2 sm:gap-4">
            {[
              { value: timeLeft.days, label: 'Dias' },
              { value: timeLeft.hours, label: 'Horas' },
              { value: timeLeft.minutes, label: 'Min' },
              { value: timeLeft.seconds, label: 'Seg' },
            ].map((item, index) => (
              <div key={item.label} className="flex items-center gap-2 sm:gap-4">
                <div className="flex flex-col items-center">
                  <div className="bg-black/60 border border-yellow-500/30 rounded-xl w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center">
                    <span className="text-xl sm:text-2xl font-black text-yellow-400 tabular-nums">
                      {String(item.value).padStart(2, '0')}
                    </span>
                  </div>
                  <span className="text-gray-500 text-[10px] font-semibold mt-1.5 tracking-wider uppercase">
                    {item.label}
                  </span>
                </div>
                {index < 3 && (
                  <span className="text-yellow-500/60 text-xl sm:text-2xl font-black mb-4 select-none">:</span>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
